<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">

  <div class="row">

    <div class="text-center m-auto col-sm-12">
      <h3 class="col-sm-12"  style="background-color: black; color: white; padding: 10px;">Push to unit</h3>

        <form (ngSubmit)="openDialogPush()" #ff="ngForm">

          <div class="container-fluid text-center">
            <div id="generalSettings" class="row text-center">
              <h3 class="col-sm-12" style="background-color: grey;padding: 5px;font-weight: bold;">General Settings</h3>

              <div class="col-sm-6 text-center">

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>System Name</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.system_name"  autocomplete="off"
                    name="system_name" required  minlength="3" #sysName="ngModel">
                    <mat-error *ngIf="sysName.errors">
                      System Name is required
                    </mat-error>
                  </mat-form-field>
                </div>



                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Time Zone</mat-label>
                    <mat-select [(ngModel)]="endpoint_data_ToBe_Edited.system_time_zone"  name="system_time_zone">
                      <mat-option *ngFor="let zone of availableTimeZones"  [value]="zone">{{zone}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>IP</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.system_ip"  autocomplete="off" [disabled]="true"
                    name="system_ip" required maxlength="15" minlength="7" #ipAddr="ngModel"
                    pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$">
                    <mat-error *ngIf="ipAddr.errors">
                      Invalid IPV4 format
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>MAC Address</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.system_mac_address"
                    autocomplete="off" [disabled]="true"
                    name="system_mac_address" >
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Software Name</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.software_name"
                    autocomplete="off" [disabled]="true"
                    name="software_name" >
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Software Version</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.software_version"
                    autocomplete="off" [disabled]="true"
                    name="software_version" >
                  </mat-form-field>
                </div>

              </div>

              <div class="col-sm-6 text-center">


                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Serial Number</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.serial_number"
                    autocomplete="off" [disabled]="true"
                    name="serial_number" >
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Product ID</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.product_id"
                    autocomplete="off" [disabled]="true"
                    name="product_id" >
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>PhoneBook</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.phonebook_fk_id"
                    autocomplete="off" [disabled]="true"
                    name="phonebook_fk_id" >
                  </mat-form-field>
                </div>



                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Enable PhoneBook</mat-label>
                    <mat-select [(ngModel)]="endpoint_data_ToBe_Edited.enable_phonebook"  name="enable_phonebook">
                      <mat-option *ngFor="let option of onAndOffOptions"  [value]="option" [disabled]="true">{{option}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


              </div>

            </div>

            <div id="sipSettings" class="row text-center">
              <h3 class="col-sm-12" style="background-color: grey;padding: 5px;font-weight: bold;">SIP Settings</h3>

              <div class="col-sm-6 text-center">
                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>System SIP Name</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_display_name"  autocomplete="off"
                    name="sip_display_name" required  minlength="3" #sysSIPName="ngModel">
                    <mat-error *ngIf="sysSIPName.errors">
                      System SIP Name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>SIP Proxy Address 1</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_proxy_address"  autocomplete="off"
                    name="sip_proxy_address" required  minlength="3" #sip_proxy_address="ngModel">
                    <mat-error *ngIf="sip_proxy_address.errors">
                      Required
                    </mat-error>
                  </mat-form-field>
                </div>


                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>SIP Proxy Address 1 Status </mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_proxy_address_status"  autocomplete="off"
                    name="sip_proxy_address_status" [disabled]="true">
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>SIP Proxy Address 2</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_proxy_address2"  autocomplete="off"
                    name="sip_proxy_address2"  minlength="3" #sip_proxy_address2="ngModel">
                    <mat-error *ngIf="sip_proxy_address2.errors">
                      Length (6-50)
                    </mat-error>
                  </mat-form-field>
                </div>


                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>SIP Proxy Address 2 Status</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_proxy_address2_status"  autocomplete="off"
                    name="sip_proxy_address2_status" [disabled]="true">
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>SIP Registration Status</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_registration_status"  autocomplete="off"
                    name="sip_registration_status" [disabled]="true">
                  </mat-form-field>
                </div>



              </div>

              <div class="col-sm-6 text-center">
                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Tls Verify</mat-label>
                    <mat-select [(ngModel)]="endpoint_data_ToBe_Edited.sip_tls_verify"  name="sip_tls_verify">
                      <mat-option *ngFor="let option of onAndOffOptions"  [value]="option">{{option}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>SIP Registration URI</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_registration_uri"  autocomplete="off"
                    name="sip_registration_uri" required  minlength="3" #sip_registration_uri="ngModel">
                    <mat-error *ngIf="sip_registration_uri.errors">
                      Required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Sip Listen Port</mat-label>
                    <mat-select [(ngModel)]="endpoint_data_ToBe_Edited.sip_listen_port"  name="sip_listen_port">
                      <mat-option *ngFor="let option of onAndOffOptions"  [value]="option">{{option}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Sip Authentication</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_authentication"  autocomplete="off"
                    name="sip_authentication" [disabled]="true">
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Sip Authentication Username</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_authentication_username"  autocomplete="off"
                    name="sip_authentication_username">
                  </mat-form-field>
                </div>


                <div>
                  <mat-checkbox name="checkedAuthenticationPassword" #disabler [(ngModel)]="checkedAuthenticationPassword"></mat-checkbox>
                  <mat-form-field  appearance="fill">
                    <mat-label>Sip Authentication Password</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.sip_authentication_password"  autocomplete="off"
                    name="sip_authentication_password" [disabled]="!disabler.checked" minlength="3"  #sip_authentication_password="ngModel">
                    <mat-error *ngIf="sip_authentication_password.errors">
                      Min. length 6 chars
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>Enable SIP</mat-label>
                    <mat-select [(ngModel)]="endpoint_data_ToBe_Edited.enable_sip"  name="enable_sip">
                      <mat-option *ngFor="let option of onAndOffOptions"  [value]="option">{{option}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


              </div>

            </div>


            <div id="h323Settings" class="row text-center">
              <h3 class="col-sm-12" style="background-color: grey;padding: 5px;font-weight: bold;">H323 Settings</h3>

              <div class="col-sm-6 text-center">

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>H323 Gatekeeper Address</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.h323_gatekeeper_address"  autocomplete="off"
                    name="h323_gatekeeper_address" maxlength="15" minlength="7" #h323_gatekeeper_add="ngModel"
                    pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$">
                    <mat-error *ngIf="h323_gatekeeper_add.errors">
                      Invalid format
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>H323 Gatekeeper Port</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.h323_gatekeeper_port"  autocomplete="off"
                    name="h323_gatekeeper_port" [disabled]="true">
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>H323 Gatekeeper Mode</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.h323_gatekeeper_mode"  autocomplete="off"
                    name="h323_gatekeeper_mode" [disabled]="true">
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>H323 Gatekeeper Status</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.h323_gatekeeper_status"  autocomplete="off"
                    name="h323_gatekeeper_status" [disabled]="true">
                  </mat-form-field>
                </div>


              </div>

              <div class="col-sm-6 text-center">


                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>H323 Gatekeeper Reason</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.h323_gatekeeper_reason"  autocomplete="off"
                    name="h323_gatekeeper_reason" [disabled]="true">
                  </mat-form-field>
                </div>


              <div>
                <mat-form-field  appearance="fill">
                  <mat-label>Enable H323</mat-label>
                  <mat-select [(ngModel)]="endpoint_data_ToBe_Edited.enable_h323"  name="enable_h323">
                    <mat-option *ngFor="let option of onAndOffOptions"  [value]="option">{{option}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div>
                <mat-form-field  appearance="fill">
                  <mat-label>H323 Alias E164</mat-label>
                  <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.h323_e164"  autocomplete="off"
                  name="h323_e164"  #h323_e164_="ngModel">
                </mat-form-field>
              </div>

              <div>
                <mat-form-field  appearance="fill">
                  <mat-label>H323 Alias ID</mat-label>
                  <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.h323_id"  autocomplete="off"
                  name="h323_id"  #h323_id_="ngModel">
                </mat-form-field>
              </div>
              </div>

            </div>


            <div id="otherNetworkSettings" class="row text-center">
              <h3 class="col-sm-12" style="background-color: grey;padding: 5px;font-weight: bold;">Other Settings</h3>

              <div  class="col-sm-6 text-center">

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>NTP Server 1</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.ntp_server1"  autocomplete="off"
                    name="ntp_server1"  #ntp1Addr="ngModel">
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>DNS Server 1</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.dns_server1"  autocomplete="off"
                    name="dns_server1"  #dns1Addr="ngModel" >
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>DNS Server 2</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.dns_server2"  autocomplete="off"
                    name="dns_server2"  #dns2Addr="ngModel">
                  </mat-form-field>
                </div>

              </div>

              <div  class="col-sm-6 text-center">
                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>DNS Server 3</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.dns_server3"  autocomplete="off"
                    name="dns_server3"  #dns3Addr="ngModel">
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field  appearance="fill">
                    <mat-label>DNS Domain Name</mat-label>
                    <input matInput [(ngModel)]="endpoint_data_ToBe_Edited.dns_domain_name"  autocomplete="off"
                    name="dns_domain_name"  #dnsDomainName="ngModel">
                  </mat-form-field>
                </div>


              </div>

            </div>

            <div id="buttonsAndError" class=" row">
              <div class="col-sm-12">
                <button mat-raised-button  color="primary"
                style="margin-left: auto;margin-right: auto; margin-top: 10px !important;"
                type="submit" [disabled]="!ff.valid || pushingToSystemFlag || !endpoint_data_received.is_provisioned  || !endpoint_data_received.system_password">Push to system</button>
              </div>
             <div class="col-sm-12 text-center" id="errorsGenerated">
                <p style="color: red;" *ngIf="!endpoint_data_received.is_provisioned">* VMS can't push to unprovisioned units </p>
                <p style="color: red;" *ngIf="!endpoint_data_received.system_password">* VMS can't push to a unit with no password </p>
              </div>
            </div>

          </div>

        </form>

    </div>

  </div>

</div>

